import { render, staticRenderFns } from "./fields-area.component.vue?vue&type=template&id=8970bef6&scoped=true&"
var script = {}
import style0 from "./fields-area.component.vue?vue&type=style&index=0&id=8970bef6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8970bef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
